import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Skeleton } from "antd";

import AuthProvider from "./providers/AuthProvider";
import { publicRoutes, protectedRoutes } from "./routes";
import PublicLayout from "./layout/PublicLayout";
import ProtectedLayout from "./layout/ProtectedLayout";

const Router = () => {
  return (
    <AuthProvider>
      <Routes>
        {/** Public Routes **/}
        <Route element={<PublicLayout />}>
          {publicRoutes.map((route, i) => {
            return (
              <Route
                key={`public-${i}`}
                path={route.path}
                element={
                  <Suspense fallback={<Skeleton />}>
                    <route.element />
                  </Suspense>
                }
              />
            );
          })}
        </Route>

        {/** Protected Routes **/}
        <Route path="/" element={<ProtectedLayout />}>
          {protectedRoutes.map((route, i) => {
            return (
              <Route
                key={`protected-${i}`}
                path={route.path}
                element={
                  <Suspense fallback={<Skeleton />}>
                    <route.element />
                  </Suspense>
                }
              />
            );
          })}
        </Route>
      </Routes>
    </AuthProvider>
  );
};

export default Router;
